import "core-js/modules/esnext.global-this.js";
import * as e from "react";
import n from "react";
import { WmkImage as t, Img as r } from "wmk-image";
import { WmkLink as o } from "wmk-link";
import { Container as l, Row as E, Col as a } from "react-bootstrap";
import u from "react-player";

var L,
    _i = function i() {
  return _i = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var o in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }, _i.apply(this, arguments);
};

function c(e, n, t) {
  if (t || 2 === arguments.length) for (var r, o = 0, l = n.length; o < l; o++) {
    !r && o in n || (r || (r = Array.prototype.slice.call(n, 0, o)), r[o] = n[o]);
  }
  return e.concat(r || Array.prototype.slice.call(n));
}

!function (e) {
  e.EMBEDDED = "embedded", e.PARAGRAPH = "paragraph", e.HEADING = "heading", e.ENTRY = "entry", e.ASSET = "asset", e.HORIZONTAL_RULE = "hr", e.LIST = "list", e.TEXT = "text", e.INLINE = "inline";
}(L || (L = {}));

var S = function S(e) {
  var n = this;
  this.getRef = function (e) {
    return e in n.hash ? n.hash[e] : void 0;
  }, this.handleRef = function (e) {
    var t,
        r,
        o = e.data,
        l = null === (r = null === (t = null == o ? void 0 : o.target) || void 0 === t ? void 0 : t.sys) || void 0 === r ? void 0 : r.id,
        E = _i({}, n.getRef(l));

    return (null == E ? void 0 : E.__typename) ? _i(_i({}, e), {
      reference: {
        __typename: E.__typename,
        data: _i({}, E)
      }
    }) : _i(_i({}, e), {
      reference: {
        __typename: "error",
        data: {
          error: "check query, make sure to add contentful_id",
          contentful_id: l
        }
      }
    });
  }, this.hasRef = function (e) {
    return Array.isArray(e.nodeType.match(new RegExp("".concat(L.EMBEDDED, "|").concat(L.ENTRY, "|").concat(L.ASSET))));
  }, this.traverseBlocks = function (e) {
    return e.map(function (e) {
      return n.hasRef(e) ? n.handleRef(e) : "content" in e ? _i(_i({}, e), {
        content: n.traverseBlocks(e.content)
      }) : e;
    });
  }, this.richText = function () {
    return n.json && Array.isArray(n.json.content) ? _i(_i({}, n.json), {
      content: n.traverseBlocks(c([], n.json.content, !0))
    }) : void 0;
  }, this.excerpt = function (e) {
    var t;
    void 0 === e && (e = 156);
    var r = null === (t = n.json) || void 0 === t ? void 0 : t.content,
        o = "";
    return Array.isArray(r) && r.forEach(function (n) {
      if ("paragraph" === n.nodeType) {
        var t = n.content;
        if (Array.isArray(t)) for (var r = 0; o.length < e && r < t.length;) {
          t.forEach(function (e) {
            var n;
            "text" === e.nodeType ? (o += e.value, r++) : (o = Array.isArray(e.content) && e.content[0] && "value" in e.content[0] ? null === (n = e.content[0]) || void 0 === n ? void 0 : n.value : "", r++);
          });
        }
      }
    }), o.length > e ? o.slice(0, e) + "..." : o;
  };
  var t = (null == e ? void 0 : e.references) ? e.references : [],
      r = null == e ? void 0 : e.raw,
      o = r ? JSON.parse(r) : void 0;
  this.raw = r, this.references = t, this.hash = t.reduce(function (e, n) {
    return e[n.contentful_id] = n, e;
  }, {}), this.json = o;
},
    d = function d() {
  return n.createElement(n.Fragment, null);
},
    O = function () {
  function e(e, t) {
    var r,
        o = null == e ? void 0 : e.reference,
        l = null == o ? void 0 : o.__typename,
        E = null === (r = null == o ? void 0 : o.data) || void 0 === r ? void 0 : r.contentful_id,
        a = null == o ? void 0 : o.data;
    this.props = a, this.Comp = l ? function (e) {
      var r,
          l = "error" === e ? function () {
        return n.createElement(n.Fragment, null, console.log("problem with rich text reference query", o.data));
      } : e in t ? t[e] : void 0;
      return l || (E ? "error" === e ? console.log("Error retrieving reference data for ".concat(e, " / ").concat(E)) : console.log("No ".concat(e, " component defined in hash for contentful_id: ").concat(E, ".")) : console.log("contentful_id is missing on reference data for ".concat(e, " / ").concat(null === (r = null == o ? void 0 : o.data) || void 0 === r ? void 0 : r.__typename, "\n            }"))), l || d;
    }(l) : d, this.hash = t;
  }

  return e.prototype.render = function () {
    var e = this.Comp,
        t = this.props;
    return n.createElement(e, _i({}, t));
  }, e.prototype.setComp = function (e) {
    this.Comp = e || d;
  }, e;
}(),
    _ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    B = {};

!function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var t,
      r = n,
      o = (t = r) && "object" == typeof t && "default" in t ? t.default : t,
      _l = function l() {
    return _l = Object.assign || function (e) {
      for (var n, t = 1, r = arguments.length; t < r; t++) {
        for (var o in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }, _l.apply(this, arguments);
  },
      E = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== _ ? _ : "undefined" != typeof self ? self : {};

  function a(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function u(e, n) {
    return e(n = {
      exports: {}
    }, n.exports), n.exports;
  }

  var L = u(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.BLOCKS = void 0, (t = n.BLOCKS || (n.BLOCKS = {})).DOCUMENT = "document", t.PARAGRAPH = "paragraph", t.HEADING_1 = "heading-1", t.HEADING_2 = "heading-2", t.HEADING_3 = "heading-3", t.HEADING_4 = "heading-4", t.HEADING_5 = "heading-5", t.HEADING_6 = "heading-6", t.OL_LIST = "ordered-list", t.UL_LIST = "unordered-list", t.LIST_ITEM = "list-item", t.HR = "hr", t.QUOTE = "blockquote", t.EMBEDDED_ENTRY = "embedded-entry-block", t.EMBEDDED_ASSET = "embedded-asset-block", t.TABLE = "table", t.TABLE_ROW = "table-row", t.TABLE_CELL = "table-cell", t.TABLE_HEADER_CELL = "table-header-cell";
  });
  a(L), L.BLOCKS;
  var i = u(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.INLINES = void 0, (t = n.INLINES || (n.INLINES = {})).HYPERLINK = "hyperlink", t.ENTRY_HYPERLINK = "entry-hyperlink", t.ASSET_HYPERLINK = "asset-hyperlink", t.EMBEDDED_ENTRY = "embedded-entry-inline";
  });
  a(i), i.INLINES;
  var c = u(function (e, n) {
    var t;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), function (e) {
      e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code";
    }(t || (t = {})), n.default = t;
  });
  a(c);
  var S = u(function (e, n) {
    var t,
        r = E && E.__spreadArray || function (e, n, t) {
      if (t || 2 === arguments.length) for (var r, o = 0, l = n.length; o < l; o++) {
        !r && o in n || (r || (r = Array.prototype.slice.call(n, 0, o)), r[o] = n[o]);
      }
      return e.concat(r || Array.prototype.slice.call(n));
    };

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.V1_NODE_TYPES = n.TEXT_CONTAINERS = n.HEADINGS = n.CONTAINERS = n.VOID_BLOCKS = n.TABLE_BLOCKS = n.LIST_ITEM_BLOCKS = n.TOP_LEVEL_BLOCKS = void 0, n.TOP_LEVEL_BLOCKS = [L.BLOCKS.PARAGRAPH, L.BLOCKS.HEADING_1, L.BLOCKS.HEADING_2, L.BLOCKS.HEADING_3, L.BLOCKS.HEADING_4, L.BLOCKS.HEADING_5, L.BLOCKS.HEADING_6, L.BLOCKS.OL_LIST, L.BLOCKS.UL_LIST, L.BLOCKS.HR, L.BLOCKS.QUOTE, L.BLOCKS.EMBEDDED_ENTRY, L.BLOCKS.EMBEDDED_ASSET, L.BLOCKS.TABLE], n.LIST_ITEM_BLOCKS = [L.BLOCKS.PARAGRAPH, L.BLOCKS.HEADING_1, L.BLOCKS.HEADING_2, L.BLOCKS.HEADING_3, L.BLOCKS.HEADING_4, L.BLOCKS.HEADING_5, L.BLOCKS.HEADING_6, L.BLOCKS.OL_LIST, L.BLOCKS.UL_LIST, L.BLOCKS.HR, L.BLOCKS.QUOTE, L.BLOCKS.EMBEDDED_ENTRY, L.BLOCKS.EMBEDDED_ASSET], n.TABLE_BLOCKS = [L.BLOCKS.TABLE, L.BLOCKS.TABLE_ROW, L.BLOCKS.TABLE_CELL, L.BLOCKS.TABLE_HEADER_CELL], n.VOID_BLOCKS = [L.BLOCKS.HR, L.BLOCKS.EMBEDDED_ENTRY, L.BLOCKS.EMBEDDED_ASSET], n.CONTAINERS = ((t = {})[L.BLOCKS.OL_LIST] = [L.BLOCKS.LIST_ITEM], t[L.BLOCKS.UL_LIST] = [L.BLOCKS.LIST_ITEM], t[L.BLOCKS.LIST_ITEM] = n.LIST_ITEM_BLOCKS, t[L.BLOCKS.QUOTE] = [L.BLOCKS.PARAGRAPH], t[L.BLOCKS.TABLE] = [L.BLOCKS.TABLE_ROW], t[L.BLOCKS.TABLE_ROW] = [L.BLOCKS.TABLE_CELL, L.BLOCKS.TABLE_HEADER_CELL], t[L.BLOCKS.TABLE_CELL] = [L.BLOCKS.PARAGRAPH], t[L.BLOCKS.TABLE_HEADER_CELL] = [L.BLOCKS.PARAGRAPH], t), n.HEADINGS = [L.BLOCKS.HEADING_1, L.BLOCKS.HEADING_2, L.BLOCKS.HEADING_3, L.BLOCKS.HEADING_4, L.BLOCKS.HEADING_5, L.BLOCKS.HEADING_6], n.TEXT_CONTAINERS = r([L.BLOCKS.PARAGRAPH], n.HEADINGS, !0), n.V1_NODE_TYPES = [L.BLOCKS.DOCUMENT, L.BLOCKS.PARAGRAPH, L.BLOCKS.HEADING_1, L.BLOCKS.HEADING_2, L.BLOCKS.HEADING_3, L.BLOCKS.HEADING_4, L.BLOCKS.HEADING_5, L.BLOCKS.HEADING_6, L.BLOCKS.OL_LIST, L.BLOCKS.UL_LIST, L.BLOCKS.LIST_ITEM, L.BLOCKS.HR, L.BLOCKS.QUOTE, L.BLOCKS.EMBEDDED_ENTRY, L.BLOCKS.EMBEDDED_ASSET, i.INLINES.HYPERLINK, i.INLINES.ENTRY_HYPERLINK, i.INLINES.ASSET_HYPERLINK, i.INLINES.EMBEDDED_ENTRY, "text"];
  });
  a(S), S.V1_NODE_TYPES, S.TEXT_CONTAINERS, S.HEADINGS, S.CONTAINERS, S.VOID_BLOCKS, S.TABLE_BLOCKS, S.LIST_ITEM_BLOCKS, S.TOP_LEVEL_BLOCKS;
  var d = u(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
  });
  a(d);
  var O = u(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
  });
  a(O);
  var B = u(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var t = {
      nodeType: L.BLOCKS.DOCUMENT,
      data: {},
      content: [{
        nodeType: L.BLOCKS.PARAGRAPH,
        data: {},
        content: [{
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }]
      }]
    };
    n.default = t;
  });
  a(B);
  var N = u(function (e, n) {
    function t(e, n) {
      for (var t = 0, r = Object.keys(e); t < r.length; t++) {
        if (n === e[r[t]]) return !0;
      }

      return !1;
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isText = n.isBlock = n.isInline = void 0, n.isInline = function (e) {
      return t(i.INLINES, e.nodeType);
    }, n.isBlock = function (e) {
      return t(L.BLOCKS, e.nodeType);
    }, n.isText = function (e) {
      return "text" === e.nodeType;
    };
  });
  a(N), N.isText, N.isBlock, N.isInline;
  var I = u(function (e, n) {
    var t = E && E.__createBinding || (Object.create ? function (e, n, t, r) {
      void 0 === r && (r = t);
      var o = Object.getOwnPropertyDescriptor(n, t);
      o && !("get" in o ? !n.__esModule : o.writable || o.configurable) || (o = {
        enumerable: !0,
        get: function get() {
          return n[t];
        }
      }), Object.defineProperty(e, r, o);
    } : function (e, n, t, r) {
      void 0 === r && (r = t), e[r] = n[t];
    }),
        r = E && E.__setModuleDefault || (Object.create ? function (e, n) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: n
      });
    } : function (e, n) {
      e.default = n;
    }),
        o = E && E.__exportStar || function (e, n) {
      for (var r in e) {
        "default" === r || Object.prototype.hasOwnProperty.call(n, r) || t(n, e, r);
      }
    },
        l = E && E.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var n = {};
      if (null != e) for (var o in e) {
        "default" !== o && Object.prototype.hasOwnProperty.call(e, o) && t(n, e, o);
      }
      return r(n, e), n;
    },
        a = E && E.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.helpers = n.EMPTY_DOCUMENT = n.MARKS = n.INLINES = n.BLOCKS = void 0, Object.defineProperty(n, "BLOCKS", {
      enumerable: !0,
      get: function get() {
        return L.BLOCKS;
      }
    }), Object.defineProperty(n, "INLINES", {
      enumerable: !0,
      get: function get() {
        return i.INLINES;
      }
    }), Object.defineProperty(n, "MARKS", {
      enumerable: !0,
      get: function get() {
        return a(c).default;
      }
    }), o(S, n), o(d, n), o(O, n), Object.defineProperty(n, "EMPTY_DOCUMENT", {
      enumerable: !0,
      get: function get() {
        return a(B).default;
      }
    });
    var u = l(N);
    n.helpers = u;
  });
  a(I);
  var A = I.helpers;
  I.EMPTY_DOCUMENT;
  var C,
      T,
      f = I.MARKS,
      K = I.INLINES,
      D = I.BLOCKS;

  function s(e, n) {
    return e.map(function (e, t) {
      return o = v(e, n), l = t, r.isValidElement(o) && null === o.key ? r.cloneElement(o, {
        key: l
      }) : o;
      var o, l;
    });
  }

  function v(e, n) {
    var t = n.renderNode,
        r = n.renderMark,
        l = n.renderText;
    if (A.isText(e)) return e.marks.reduce(function (e, n) {
      return r[n.type] ? r[n.type](e) : e;
    }, l ? l(e.value) : e.value);
    var E = s(e.content, n);
    return e.nodeType && t[e.nodeType] ? t[e.nodeType](e, E) : o.createElement(o.Fragment, null, E);
  }

  var p = ((C = {})[D.DOCUMENT] = function (e, n) {
    return n;
  }, C[D.PARAGRAPH] = function (e, n) {
    return o.createElement("p", null, n);
  }, C[D.HEADING_1] = function (e, n) {
    return o.createElement("h1", null, n);
  }, C[D.HEADING_2] = function (e, n) {
    return o.createElement("h2", null, n);
  }, C[D.HEADING_3] = function (e, n) {
    return o.createElement("h3", null, n);
  }, C[D.HEADING_4] = function (e, n) {
    return o.createElement("h4", null, n);
  }, C[D.HEADING_5] = function (e, n) {
    return o.createElement("h5", null, n);
  }, C[D.HEADING_6] = function (e, n) {
    return o.createElement("h6", null, n);
  }, C[D.EMBEDDED_ENTRY] = function (e, n) {
    return o.createElement("div", null, n);
  }, C[D.UL_LIST] = function (e, n) {
    return o.createElement("ul", null, n);
  }, C[D.OL_LIST] = function (e, n) {
    return o.createElement("ol", null, n);
  }, C[D.LIST_ITEM] = function (e, n) {
    return o.createElement("li", null, n);
  }, C[D.QUOTE] = function (e, n) {
    return o.createElement("blockquote", null, n);
  }, C[D.HR] = function () {
    return o.createElement("hr", null);
  }, C[D.TABLE] = function (e, n) {
    return o.createElement("table", null, o.createElement("tbody", null, n));
  }, C[D.TABLE_ROW] = function (e, n) {
    return o.createElement("tr", null, n);
  }, C[D.TABLE_HEADER_CELL] = function (e, n) {
    return o.createElement("th", null, n);
  }, C[D.TABLE_CELL] = function (e, n) {
    return o.createElement("td", null, n);
  }, C[K.ASSET_HYPERLINK] = function (e) {
    return R(K.ASSET_HYPERLINK, e);
  }, C[K.ENTRY_HYPERLINK] = function (e) {
    return R(K.ENTRY_HYPERLINK, e);
  }, C[K.EMBEDDED_ENTRY] = function (e) {
    return R(K.EMBEDDED_ENTRY, e);
  }, C[K.HYPERLINK] = function (e, n) {
    return o.createElement("a", {
      href: e.data.uri
    }, n);
  }, C),
      y = ((T = {})[f.BOLD] = function (e) {
    return o.createElement("b", null, e);
  }, T[f.ITALIC] = function (e) {
    return o.createElement("i", null, e);
  }, T[f.UNDERLINE] = function (e) {
    return o.createElement("u", null, e);
  }, T[f.CODE] = function (e) {
    return o.createElement("code", null, e);
  }, T);

  function R(e, n) {
    return o.createElement("span", {
      key: n.data.target.sys.id
    }, "type: ", n.nodeType, " id: ", n.data.target.sys.id);
  }

  e.documentToReactComponents = function (e, n) {
    return void 0 === n && (n = {}), e ? v(e, {
      renderNode: _l(_l({}, p), n.renderNode),
      renderMark: _l(_l({}, y), n.renderMark),
      renderText: n.renderText
    }) : null;
  };
}(B);
var N,
    I,
    A = {},
    C = {};
N = C, Object.defineProperty(N, "__esModule", {
  value: !0
}), N.BLOCKS = void 0, (I = N.BLOCKS || (N.BLOCKS = {})).DOCUMENT = "document", I.PARAGRAPH = "paragraph", I.HEADING_1 = "heading-1", I.HEADING_2 = "heading-2", I.HEADING_3 = "heading-3", I.HEADING_4 = "heading-4", I.HEADING_5 = "heading-5", I.HEADING_6 = "heading-6", I.OL_LIST = "ordered-list", I.UL_LIST = "unordered-list", I.LIST_ITEM = "list-item", I.HR = "hr", I.QUOTE = "blockquote", I.EMBEDDED_ENTRY = "embedded-entry-block", I.EMBEDDED_ASSET = "embedded-asset-block", I.TABLE = "table", I.TABLE_ROW = "table-row", I.TABLE_CELL = "table-cell", I.TABLE_HEADER_CELL = "table-header-cell";
var T = {};
!function (e) {
  var n;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.INLINES = void 0, (n = e.INLINES || (e.INLINES = {})).HYPERLINK = "hyperlink", n.ENTRY_HYPERLINK = "entry-hyperlink", n.ASSET_HYPERLINK = "asset-hyperlink", n.EMBEDDED_ENTRY = "embedded-entry-inline";
}(T);
var f,
    K = {};
Object.defineProperty(K, "__esModule", {
  value: !0
}), function (e) {
  e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code";
}(f || (f = {})), K.default = f;
var D = {};
!function (e) {
  var n,
      t = _ && _.__spreadArray || function (e, n, t) {
    if (t || 2 === arguments.length) for (var r, o = 0, l = n.length; o < l; o++) {
      !r && o in n || (r || (r = Array.prototype.slice.call(n, 0, o)), r[o] = n[o]);
    }
    return e.concat(r || Array.prototype.slice.call(n));
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.V1_NODE_TYPES = e.TEXT_CONTAINERS = e.HEADINGS = e.CONTAINERS = e.VOID_BLOCKS = e.TABLE_BLOCKS = e.LIST_ITEM_BLOCKS = e.TOP_LEVEL_BLOCKS = void 0;
  var r = C,
      o = T;
  e.TOP_LEVEL_BLOCKS = [r.BLOCKS.PARAGRAPH, r.BLOCKS.HEADING_1, r.BLOCKS.HEADING_2, r.BLOCKS.HEADING_3, r.BLOCKS.HEADING_4, r.BLOCKS.HEADING_5, r.BLOCKS.HEADING_6, r.BLOCKS.OL_LIST, r.BLOCKS.UL_LIST, r.BLOCKS.HR, r.BLOCKS.QUOTE, r.BLOCKS.EMBEDDED_ENTRY, r.BLOCKS.EMBEDDED_ASSET, r.BLOCKS.TABLE], e.LIST_ITEM_BLOCKS = [r.BLOCKS.PARAGRAPH, r.BLOCKS.HEADING_1, r.BLOCKS.HEADING_2, r.BLOCKS.HEADING_3, r.BLOCKS.HEADING_4, r.BLOCKS.HEADING_5, r.BLOCKS.HEADING_6, r.BLOCKS.OL_LIST, r.BLOCKS.UL_LIST, r.BLOCKS.HR, r.BLOCKS.QUOTE, r.BLOCKS.EMBEDDED_ENTRY, r.BLOCKS.EMBEDDED_ASSET], e.TABLE_BLOCKS = [r.BLOCKS.TABLE, r.BLOCKS.TABLE_ROW, r.BLOCKS.TABLE_CELL, r.BLOCKS.TABLE_HEADER_CELL], e.VOID_BLOCKS = [r.BLOCKS.HR, r.BLOCKS.EMBEDDED_ENTRY, r.BLOCKS.EMBEDDED_ASSET], e.CONTAINERS = ((n = {})[r.BLOCKS.OL_LIST] = [r.BLOCKS.LIST_ITEM], n[r.BLOCKS.UL_LIST] = [r.BLOCKS.LIST_ITEM], n[r.BLOCKS.LIST_ITEM] = e.LIST_ITEM_BLOCKS, n[r.BLOCKS.QUOTE] = [r.BLOCKS.PARAGRAPH], n[r.BLOCKS.TABLE] = [r.BLOCKS.TABLE_ROW], n[r.BLOCKS.TABLE_ROW] = [r.BLOCKS.TABLE_CELL, r.BLOCKS.TABLE_HEADER_CELL], n[r.BLOCKS.TABLE_CELL] = [r.BLOCKS.PARAGRAPH], n[r.BLOCKS.TABLE_HEADER_CELL] = [r.BLOCKS.PARAGRAPH], n), e.HEADINGS = [r.BLOCKS.HEADING_1, r.BLOCKS.HEADING_2, r.BLOCKS.HEADING_3, r.BLOCKS.HEADING_4, r.BLOCKS.HEADING_5, r.BLOCKS.HEADING_6], e.TEXT_CONTAINERS = t([r.BLOCKS.PARAGRAPH], e.HEADINGS, !0), e.V1_NODE_TYPES = [r.BLOCKS.DOCUMENT, r.BLOCKS.PARAGRAPH, r.BLOCKS.HEADING_1, r.BLOCKS.HEADING_2, r.BLOCKS.HEADING_3, r.BLOCKS.HEADING_4, r.BLOCKS.HEADING_5, r.BLOCKS.HEADING_6, r.BLOCKS.OL_LIST, r.BLOCKS.UL_LIST, r.BLOCKS.LIST_ITEM, r.BLOCKS.HR, r.BLOCKS.QUOTE, r.BLOCKS.EMBEDDED_ENTRY, r.BLOCKS.EMBEDDED_ASSET, o.INLINES.HYPERLINK, o.INLINES.ENTRY_HYPERLINK, o.INLINES.ASSET_HYPERLINK, o.INLINES.EMBEDDED_ENTRY, "text"];
}(D);
var s = {};
Object.defineProperty(s, "__esModule", {
  value: !0
});
var v = {};
Object.defineProperty(v, "__esModule", {
  value: !0
});
var p = {};
Object.defineProperty(p, "__esModule", {
  value: !0
});
var y = C,
    R = {
  nodeType: y.BLOCKS.DOCUMENT,
  data: {},
  content: [{
    nodeType: y.BLOCKS.PARAGRAPH,
    data: {},
    content: [{
      nodeType: "text",
      value: "",
      marks: [],
      data: {}
    }]
  }]
};
p.default = R;
var H = {};
Object.defineProperty(H, "__esModule", {
  value: !0
}), H.isText = H.isBlock = H.isInline = void 0;
var m = C,
    h = T;

function P(e, n) {
  for (var t = 0, r = Object.keys(e); t < r.length; t++) {
    if (n === e[r[t]]) return !0;
  }

  return !1;
}

H.isInline = function (e) {
  return P(h.INLINES, e.nodeType);
}, H.isBlock = function (e) {
  return P(m.BLOCKS, e.nodeType);
}, H.isText = function (e) {
  return "text" === e.nodeType;
}, function (e) {
  var n = _ && _.__createBinding || (Object.create ? function (e, n, t, r) {
    void 0 === r && (r = t);
    var o = Object.getOwnPropertyDescriptor(n, t);
    o && !("get" in o ? !n.__esModule : o.writable || o.configurable) || (o = {
      enumerable: !0,
      get: function get() {
        return n[t];
      }
    }), Object.defineProperty(e, r, o);
  } : function (e, n, t, r) {
    void 0 === r && (r = t), e[r] = n[t];
  }),
      t = _ && _.__setModuleDefault || (Object.create ? function (e, n) {
    Object.defineProperty(e, "default", {
      enumerable: !0,
      value: n
    });
  } : function (e, n) {
    e.default = n;
  }),
      r = _ && _.__exportStar || function (e, t) {
    for (var r in e) {
      "default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
    }
  },
      o = _ && _.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var r = {};
    if (null != e) for (var o in e) {
      "default" !== o && Object.prototype.hasOwnProperty.call(e, o) && n(r, e, o);
    }
    return t(r, e), r;
  },
      l = _ && _.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.helpers = e.EMPTY_DOCUMENT = e.MARKS = e.INLINES = e.BLOCKS = void 0;
  var E = C;
  Object.defineProperty(e, "BLOCKS", {
    enumerable: !0,
    get: function get() {
      return E.BLOCKS;
    }
  });
  var a = T;
  Object.defineProperty(e, "INLINES", {
    enumerable: !0,
    get: function get() {
      return a.INLINES;
    }
  });
  var u = K;
  Object.defineProperty(e, "MARKS", {
    enumerable: !0,
    get: function get() {
      return l(u).default;
    }
  }), r(D, e), r(s, e), r(v, e);
  var L = p;
  Object.defineProperty(e, "EMPTY_DOCUMENT", {
    enumerable: !0,
    get: function get() {
      return l(L).default;
    }
  });
  var i = o(H);
  e.helpers = i;
}(A);

var G,
    M,
    b = {
  "ordered-list": function orderedList(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("ol", {
      style: r
    }, t);
  },
  "unordered-list": function unorderedList(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("ul", {
      style: r
    }, t);
  }
},
    g = {
  paragraph: function paragraph(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("div", {
      className: "p",
      style: r
    }, t);
  },
  "heading-1": function heading1(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h1", {
      style: r
    }, t);
  },
  "heading-2": function heading2(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h2", {
      style: r
    }, t);
  },
  "heading-3": function heading3(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h3", {
      style: r
    }, t);
  },
  "heading-4": function heading4(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h4", {
      style: r
    }, t);
  },
  "heading-5": function heading5(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h5", {
      style: r
    }, t);
  },
  "heading-6": function heading6(e) {
    var t = e.children,
        r = e.style;
    return n.createElement("h6", {
      style: r
    }, t);
  }
},
    Y = function Y(e) {
  var t = e.children;
  return n.createElement(n.Fragment, null, t);
},
    j = function j(e, t, r) {
  var o = e.nodeType in g ? g[e.nodeType] : function (e) {
    var t = e.children;
    return n.createElement(n.Fragment, null, t);
  };
  return (null == r ? void 0 : r.Component) ? (null == r ? void 0 : r.Wrapper) ? n.createElement(r.Wrapper, null, n.createElement(r.Component, {
    node: e
  }, t)) : n.createElement(r.Component, {
    node: e
  }, t) : (null == r ? void 0 : r.Wrapper) ? n.createElement(r.Wrapper, null, n.createElement(o, null, t)) : n.createElement(o, null, t);
},
    k = function k(e, t, r) {
  return new O(e, r || {
    Error: function Error() {
      return n.createElement("code", null, t, "Use: (node: RichTextNode) =&gt blocksEmbeddedEntry(node, blockHash), pass blockHash object.", console.log("   Use: (node: RichTextNode) => blocksEmbeddedEntry(node,\n              blockHash), pass blockHash object."));
    }
  }).render();
},
    U = function U(e, t, r) {
  var o = e.nodeType in b ? b[e.nodeType] : Y;
  return (null == r ? void 0 : r.Bullet) && Array.isArray(e.content) && Array.isArray(t) ? n.createElement(l, null, n.createElement(o, {
    style: (null == r ? void 0 : r.Bullet) ? {
      listStyleType: "none"
    } : void 0
  }, e.content.map(function (e, o) {
    return n.createElement(E, {
      key: e.nodeType + o,
      style: (null == r ? void 0 : r.rowStyle) || {
        padding: "0.25rem 0rem",
        display: "flex",
        alignItems: "flex-start"
      }
    }, n.createElement(a, {
      xs: "auto",
      style: null == r ? void 0 : r.bulletSyle
    }, r.Bullet), n.createElement(a, {
      style: null == r ? void 0 : r.textStyle
    }, W([t[o]])));
  }))) : n.createElement(o, null, W(t));
},
    x = function x(e, o, l) {
  var E,
      a,
      L,
      i = null === (E = null == e ? void 0 : e.reference) || void 0 === E ? void 0 : E.data,
      c = null === (a = null == i ? void 0 : i.file) || void 0 === a ? void 0 : a.contentType;
  return l ? n.createElement(l, {
    asset: i,
    contentType: c
  }) : c.match("image") ? n.createElement(t, {
    image: new r(i)
  }) : c.match("video") && (null === (L = null == i ? void 0 : i.file) || void 0 === L ? void 0 : L.url) ? n.createElement(u, {
    url: i.file.url
  }) : n.createElement(Y, null, o, n.createElement(n.Fragment, null, console.log("error with type: ".concat(c))));
},
    w = function w(e, t, r) {
  return r ? n.createElement(r, {
    node: e,
    children: t
  }) : n.createElement(o, {
    to: e.data.uri,
    target: "_blank"
  }, W(t));
},
    V = function V(e, t, r) {
  var o,
      l = null === (o = null == e ? void 0 : e.reference) || void 0 === o ? void 0 : o.data;
  return r ? n.createElement(r, {
    asset: l,
    textNode: t
  }) : n.createElement(Q, {
    asset: l,
    textNode: t
  });
},
    Q = function Q(e) {
  var t,
      r = e.asset,
      l = e.textNode;
  return n.createElement(o, {
    to: null === (t = null == r ? void 0 : r.file) || void 0 === t ? void 0 : t.url,
    target: "_blank"
  }, W(l));
},
    W = function W(e) {
  return n.createElement(n.Fragment, null, Array.isArray(e) ? e.map(function (e, t) {
    return "string" == typeof e ? n.createElement(Y, {
      key: t + e
    }, e) : n.createElement(Y, {
      key: "".concat(t).concat("string" === e.type ? e.type : "symbol")
    }, e);
  }) : null);
},
    F = function F(e, t, r) {
  return r ? n.createElement(r, {
    node: e,
    children: t
  }) : n.createElement(n.Fragment, null, "No Component Present for ".concat(e.nodeType));
},
    q = function q(e, t, r) {
  return n.createElement(o, {
    to: r ? r(e.reference) : (console.log("no getTo function for node:", e), "#")
  }, W(t));
},
    X = function X(e) {
  var n;
  return {
    renderNode: ((n = {})[A.BLOCKS.PARAGRAPH] = (null == e ? void 0 : e.renderNode[A.BLOCKS.PARAGRAPH]) || J[A.BLOCKS.PARAGRAPH], n[A.BLOCKS.PARAGRAPH] = (null == e ? void 0 : e.renderNode[A.BLOCKS.PARAGRAPH]) || J[A.BLOCKS.PARAGRAPH], n[A.BLOCKS.HEADING_1] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_1]) || J[A.BLOCKS.HEADING_1], n[A.BLOCKS.HEADING_2] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_2]) || J[A.BLOCKS.HEADING_2], n[A.BLOCKS.HEADING_3] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_3]) || J[A.BLOCKS.HEADING_3], n[A.BLOCKS.HEADING_4] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_4]) || J[A.BLOCKS.HEADING_4], n[A.BLOCKS.HEADING_5] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_5]) || J[A.BLOCKS.HEADING_5], n[A.BLOCKS.HEADING_6] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HEADING_6]) || J[A.BLOCKS.HEADING_6], n[A.BLOCKS.EMBEDDED_ASSET] = (null == e ? void 0 : e.renderNode[A.BLOCKS.EMBEDDED_ASSET]) || J[A.BLOCKS.EMBEDDED_ASSET], n[A.BLOCKS.EMBEDDED_ENTRY] = (null == e ? void 0 : e.renderNode[A.BLOCKS.EMBEDDED_ENTRY]) || J[A.BLOCKS.EMBEDDED_ENTRY], n[A.BLOCKS.UL_LIST] = (null == e ? void 0 : e.renderNode[A.BLOCKS.UL_LIST]) || J[A.BLOCKS.UL_LIST], n[A.BLOCKS.OL_LIST] = (null == e ? void 0 : e.renderNode[A.BLOCKS.OL_LIST]) || J[A.BLOCKS.OL_LIST], n[A.BLOCKS.LIST_ITEM] = (null == e ? void 0 : e.renderNode[A.BLOCKS.OL_LIST]) || J[A.BLOCKS.LIST_ITEM], n[A.BLOCKS.QUOTE] = (null == e ? void 0 : e.renderNode[A.BLOCKS.QUOTE]) || J[A.BLOCKS.QUOTE], n[A.BLOCKS.HR] = (null == e ? void 0 : e.renderNode[A.BLOCKS.HR]) || J[A.BLOCKS.HR], n[A.INLINES.ASSET_HYPERLINK] = (null == e ? void 0 : e.renderNode[A.INLINES.ASSET_HYPERLINK]) || J[A.INLINES.ASSET_HYPERLINK], n[A.INLINES.EMBEDDED_ENTRY] = (null == e ? void 0 : e.renderNode[A.INLINES.EMBEDDED_ENTRY]) || J[A.INLINES.EMBEDDED_ENTRY], n[A.INLINES.ENTRY_HYPERLINK] = (null == e ? void 0 : e.renderNode[A.INLINES.ENTRY_HYPERLINK]) || J[A.INLINES.ENTRY_HYPERLINK], n[A.INLINES.HYPERLINK] = (null == e ? void 0 : e.renderNode[A.INLINES.HYPERLINK]) || J[A.INLINES.HYPERLINK], n),
    renderMark: (null == e ? void 0 : e.renderMark) || Z,
    renderText: null == e ? void 0 : e.renderText
  };
},
    J = ((G = {})[A.BLOCKS.PARAGRAPH] = j, G[A.BLOCKS.HEADING_1] = j, G[A.BLOCKS.HEADING_2] = j, G[A.BLOCKS.HEADING_3] = j, G[A.BLOCKS.HEADING_4] = j, G[A.BLOCKS.HEADING_5] = j, G[A.BLOCKS.HEADING_6] = j, G[A.BLOCKS.EMBEDDED_ASSET] = x, G[A.BLOCKS.EMBEDDED_ENTRY] = function (e) {
  return k(e);
}, G[A.BLOCKS.UL_LIST] = U, G[A.BLOCKS.OL_LIST] = U, G[A.BLOCKS.LIST_ITEM] = function (n, t) {
  return e.createElement("li", {
    key: n.nodeType
  }, t);
}, G[A.BLOCKS.QUOTE] = function (n, t) {
  return e.createElement("blockquote", {
    key: n.nodeType
  }, t);
}, G[A.BLOCKS.HR] = function () {
  return e.createElement("hr", null);
}, G[A.INLINES.ASSET_HYPERLINK] = V, G[A.INLINES.ENTRY_HYPERLINK] = q, G[A.INLINES.EMBEDDED_ENTRY] = F, G[A.INLINES.HYPERLINK] = w, G),
    Z = ((M = {})[A.MARKS.BOLD] = function (n) {
  return e.createElement("b", null, n);
}, M[A.MARKS.ITALIC] = function (n) {
  return e.createElement("i", null, n);
}, M[A.MARKS.UNDERLINE] = function (n) {
  return e.createElement("u", null, n);
}, M[A.MARKS.CODE] = function (n) {
  return e.createElement("code", null, n);
}, M),
    z = function z(n) {
  var t = n.content,
      r = n.options;

  if (t) {
    var o = t.richText();
    return o ? e.createElement(e.Fragment, null, B.documentToReactComponents(o, r || X())) : e.createElement(e.Fragment, null);
  }

  return e.createElement(e.Fragment, null);
};

export { O as EmbeddedBlock, Y as NullComp, S as RichText, z as RichTextReact, x as blocksEmbeddedAsset, k as blocksEmbeddedEntry, U as blocksList, j as blocksTypography, X as getRichTextOptions, W as handleRichTextChildren, V as inlinesAssetHyperlink, F as inlinesEmbeddedEntry, q as inlinesEntryHyperlink, w as inlinesHyperlink };